import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import MainInfo from "./info";
import ClientProfileTabs from "./tabs";
import { useGetProfile } from "src/api/clients";

const ClientProfilePage = () => {
  const { data, refetch, isLoading } = useGetProfile();

  const {
    id: clientId = "",
    clientInfo,
    contactPersons = [],
    userAccounts = [],
    locations = [],
  } = data?.data || {};

  const mainInfo = {
    agreementTypeLabel: clientInfo?.agreementTypeLabel ?? "",
    startDate: clientInfo?.startDate ?? "",
    endDate: clientInfo?.endDate ?? "",
    nameAr: clientInfo?.nameAr ?? "",
    nameEn: clientInfo?.nameEn ?? "",
  };

  if (isLoading) {
    return (
      <Box
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        minHeight={"600px"}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box p={{ xs: "30px 20px", lg: "30px 0 30px 20px" }} height={"100%"}>
      <Typography mb={4} fontSize={"22px"} fontWeight={600}>
        Profile Settings
      </Typography>

      <Grid container height={"90%"}>
        <Grid
          item
          xs={12}
          lg={3.4}
          bgcolor={"#232323"}
          borderRadius={"10px"}
          px={2}
          py={3}
          mb={{ xs: 3, lg: 0 }}
        >
          <MainInfo mainInfo={mainInfo} />
        </Grid>
        <Grid item xs={0} lg={0.2} />
        <Grid item xs={12} lg={8.2}>
          <ClientProfileTabs
            contactPersons={contactPersons}
            userAccounts={userAccounts}
            locations={locations}
            refetch={refetch}
            status={clientInfo?.status as "active" | "archived"}
            clientName={mainInfo.nameEn}
            clientId={clientId}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ClientProfilePage;
